import './script/cursor.js';
import './script/header.js';
import './script/hero.js';
import './script/faqs.js';
import './script/animateonscroll.js';
import './script/scrolldown.js';
import './script/modal.js';